module.exports = __webpack_public_path__ + "assets/img/qq.c2922db0.png";